'use client';

import { getIsAnonymous, isAppClient } from '@/lib/LocalStorage';
import { appendCampaignParamsToUrl } from '@/lib/persistCampaignParams';
import clsx from 'clsx';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

type Props = {
  className?: string;
  clickedClassName?: string;
  onClick?: () => void;
};

export default function ReferralButton({ className, clickedClassName, onClick }: Props) {
  const router = useRouter();
  const pathname = usePathname();

  const [clicked, setClicked] = useState(false);
  const [userRegistered, setUserRegistered] = useState(false);
  const [pageIsApp, setPageIsApp] = useState(false);

  useEffect(() => {
    setPageIsApp(isAppClient());
    setUserRegistered(!getIsAnonymous());
  }, []);

  useEffect(() => {
    const reset = () => setClicked(false);
    const onPageShow = () => reset();
    const onVisibility = () => {
      if (document.visibilityState === 'visible') reset();
    };
    const onFocus = () => reset();
    const onPop = () => reset();

    window.addEventListener('pageshow', onPageShow);
    window.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', onFocus);
    window.addEventListener('popstate', onPop);

    return () => {
      window.removeEventListener('pageshow', onPageShow);
      window.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('popstate', onPop);
    };
  }, []);

  const handleClick = () => {
    setClicked(true);
    onClick?.();
    const path = userRegistered ? '/oner-kazan' : '/giris-yap';
    const pathWithCampaign = appendCampaignParamsToUrl(path);
    if (pageIsApp && typeof window !== 'undefined') {
      window.location.href = pathWithCampaign;
      return;
    }
    router.push(pathWithCampaign);
  };

  return (
    <button
      key={pathname}
      onClick={handleClick}
      onAnimationEnd={() => setClicked(false)}
      aria-pressed={clicked}
      className={clsx(className, clicked && clickedClassName)}
    >
      <span>%20 İndirim Kazan</span>
    </button>
  );
}
